module.exports = __webpack_public_path__ + "static/media/6.9f1a39e0.webp";